import { shallowEqual } from 'react-redux';
import { format } from 'date-fns';

import { Box } from '@zillow/constellation-10';

import { useSelector } from '../../../selectors/useSelector';

import ListingStat from './ListingStat';
import { statsContainerStyles } from './styles';

const ListingStats = () => {
  const {
    active,
    dateLastActivatedTimestamp,
    expirationDateTimestamp,
    isMultifamily,
    performance: { totalProspectCount, viewCount, isStartDateStartOfTheMonth },
  } = useSelector(
    (state) => ({
      active: state.properties.currentProperty.active,
      dateLastActivatedTimestamp: state.properties.currentProperty.dateLastActivatedTimestamp,
      expirationDateTimestamp: state.properties.currentProperty.expirationDateTimestamp,
      isMultifamily: state.properties.currentProperty.isMultifamily,
      performance: state.properties.currentProperty.performance || {},
    }),
    shallowEqual,
  );

  if (!active && !expirationDateTimestamp) {
    return null;
  }

  const dateTimestamp = Number(!active ? expirationDateTimestamp : dateLastActivatedTimestamp);
  const formattedDate = isNaN(dateTimestamp) ? '-' : format(new Date(dateTimestamp), 'MMM dd yyyy');

  return (
    <Box data-testid="ListingStats" css={statsContainerStyles.raw()}>
      {!isMultifamily && <ListingStat title={active ? 'Published' : 'Deactivated'} content={formattedDate} />}

      <ListingStat
        title={`${'Total Prospects'}${isStartDateStartOfTheMonth ? ' this month' : ''}`}
        content={totalProspectCount || '-'}
      />

      <ListingStat title={`Views${isStartDateStartOfTheMonth ? ' this month' : ''}`} content={viewCount || '-'} />
    </Box>
  );
};

export default ListingStats;
